import { FC, PropsWithChildren, Suspense } from 'react';
import { Link } from 'react-router';

import { FlexRow, Image2, Loading } from '@portal/common/components';
import { styled } from '@portal/common/theme';

const Container = styled.div({
    display: 'flex',
    flexFlow: 'column',
    height: '100vh',
});

const Navbar = styled.div({
    display: 'flex',
    flexFlow: 'row',
    height: 70,
    padding: 15,
    background: '#173F5F',
});

const Body = styled.div({
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    padding: 20,
    overflow: 'auto',
});

const StyledImage = styled(Image2)({
    boxSizing: 'border-box',
    height: '40',
});

const GuestLayout: FC<PropsWithChildren> = ({ children }) => (
    <Container>
        <Navbar>
            <FlexRow align="center">
                <Link to="/">
                    <StyledImage src={'/img/logo-ihme-staff-portal.png'} />
                </Link>
            </FlexRow>
        </Navbar>
        <Body>
            <Suspense fallback={<Loading />}>{children}</Suspense>
        </Body>
    </Container>
);

export default GuestLayout;
